import { AllOut } from './all-out';
import { ConqueringHands } from './conquering-hands';
import { EmergencyBreeding } from './emergency-breeding';
import { HelpingHands } from './helping-hands';
import { IronWill } from './iron-will';
import { Reconstruction } from './reconstruction';

export const TECHNOLOGY_LIST = [HelpingHands, ConqueringHands, AllOut, Reconstruction, EmergencyBreeding, IronWill];